<!-- 企业级-场景管理-家庭卫士 -->
<template>
  <div class="mainArea CFamilyDefender">
      

        <!-- 搜索区域 -->
        <div class="searchArea clearfix mt20">
          <el-input class="text" v-model="defenderData.paging.user_name" placeholder="请输入设备ID" clearable></el-input>
          <el-input class="text" v-model="defenderData.paging.phone_no" placeholder="请输入主账号" clearable></el-input>
          <el-input class="text" v-model="defenderData.paging.phone_no" placeholder="请输入用户姓名" clearable></el-input>
          <el-cascader
            class="text"
            :options="defenderData.sceneList"
            v-model="defenderData.paging.phone_no"
            :props="selectProps">
          </el-cascader>
          <el-button type="primary" class="serchBtn" @click="getUserList('search')">搜索</el-button>
        </div>

        <!-- 列表 -->
        <el-table
          class="tableList"
          v-loading="defenderData.loading"
          :data="defenderData.list"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="device_id"
            label="设备ID">
          </el-table-column>
          <el-table-column
            prop="device_name"
            label="设备名称">
          </el-table-column>
          <el-table-column
            prop="temperature"
            label="温度">
          </el-table-column>
          <el-table-column
            prop="humidity"
            label="湿度">
          </el-table-column>
          <el-table-column
            prop="air"
            label="空气质量">
          </el-table-column>
          <el-table-column
            label="设备状态">
            <template slot-scope="scope">
              <el-button class="status" type="text"
                :class="{offline: scope.row.device_state === '0'}"
                @click="operateDialogInfo('changeUserStatus', scope.row)">{{scope.row.device_state === '1' ? '在线' : '离线'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="account"
            label="主账号">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="用户姓名">
          </el-table-column>
          <el-table-column
            prop="scene"
            label="所属位置">
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="defenderData.pageCount > 1">
          <el-pagination
            :current-page.sync="defenderData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="defenderData.pageCount">
          </el-pagination>
        </div>

      <!-- </div> -->
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../static/js/api.js"


  export default {
    name: 'CFamilyDefender',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 家庭卫士列表数据
        defenderData: {
          // 分页数据  page为当前页，perPage为每页数量，phone_no账号搜索，user_name用户姓名搜索
          paging: {
            page: 1,
            perPage: 2,
            department_id: '0',
            phone_no: '',
            user_name: ''
          },
          // 用户列表
          // list: [],
          list: [
            {
              device_id: '1111',
              device_name: '设备1',
              temperature: '55℃',
              humidity: '122',
              air: '优',
              device_state: '1',
              account: '15770836376',
              user_name: '余婷',
              scene: '极酷物联1'
            },
            {
              device_id: '2222',
              device_name: '设备2',
              temperature: '55℃',
              humidity: '122444',
              air: '优',
              device_state: '0',
              account: '15770836376',
              user_name: 'xxxx',
              scene: '极酷物联1'
            }
          ],
          loading: false,
          // 位置列表
          sceneList: [],
        },
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children'
        }
      }
    },
    mounted(){
    },
    created: async function () {

    },
    methods: {
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.CFamilyDefender {
  // 搜索区域
  .searchArea {
    width: 100%;
    .text {
      width: 200px;
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .searchBtn {
      float: left;
    }
  }
  // 表格列表
  .tableList {
    .status {
      color: #00CC00;
    }
    .status.offline {
      color: #FF0000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CSceneManage/CFamilyDefender.vue